module.exports = __webpack_public_path__ + "media/images/spree/frontend/content/sizing/step1-18fad8395a8470ff7ca7d4db43ec3081.jpg";